// extracted by mini-css-extract-plugin
export default {"list":"EssayPreview_list__HrQ3c","item":"EssayPreview_item__HODK2","marker":"EssayPreview_marker__KDoTz","text":"EssayPreview_text__riWHu"};